var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileExport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "file_export",
    "data-name": "file export",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "file_export-2",
    "data-name": "file export",
    d: "M14,21a7,7,0,0,1-3.59-1H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0h8l6,6V7.3A7,7,0,0,1,14,21ZM14,9a5,5,0,1,0,5,5A5.006,5.006,0,0,0,14,9ZM2.455,9.875l1.363,1.363L2,13.056l1.819,1.818,1.819-1.818L7,14.418V9.875ZM9,1.5V7h5.5Zm7.61,15.66h0L13,15V10h1.5v4.25l2.86,1.69-.749,1.22Z",
    transform: "translate(2 2)",
    fill: "#383838"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileExport);
export default __webpack_public_path__ + "static/media/file_export.797a5f6ddb3c5edc346713bd7f5e94cc.svg";
export { ForwardRef as ReactComponent };